namespace $.$$ {
	export class $exso_sheets_site extends $.$exso_sheets_site {
		title() {
			return this.site_id()
		}
		site_id() {
			return this.$.$mol_state_arg.value('site') || ''
		}
		@$mol_mem
		meta() {
			const shifts = this.shifts()
			return super
				.meta()
				.replace('{d}', this.$.$exso_sheets_shifts.unique([shifts, 'device']).length.toString())
				.replace('{s}', shifts.length.toString())
		}
		@$mol_mem
		shifts() {
			const id = this.site_id()
			return super.shifts().filter(s => s.place === id)
		}
		@$mol_mem
		blowings() {
			const id = this.site_id()
			return super.blowings().filter(s => s.place === id)
		}
		@$mol_mem
		devices() {
			return Array.from(
				Map.groupBy(this.shifts(), s => s.device),
				([k, v]) =>
					v.reduce(
						(acc, shift, i) => {
							if (i === 0) return acc
							Object.entries(shift).forEach(([k, v]) => {
								if (typeof v === 'number') (acc as any)[k] += v
							})
							return acc
						},
						{ ...v[0] },
					),
			)
		}
		@$mol_mem
		columns_meta(id: any): Record<string, any> {
			switch (id) {
				case 'blowing':
					return this.$.$exso_sheets_blowings.columns()
				case 'shift':
					return this.$.$exso_sheets_shifts.columns()
			}
			return super.columns_meta(id)
		}
		info_title() {
			return this.site_id()
		}
		device_total(): readonly any[] {
			return this.device_columns('')
		}
		@$mol_mem_key
		_device_arg(id: any) {
			return super._device_arg(this.shifts_map().get(id)?.device)
		}
		@$mol_mem
		blowing_columns() {
			return this.blowings_all() ? this.blowing_columns_all() : super.blowing_columns()
		}
	}
}
